import DoglinkElement from "./DoglinkElement";
import icons from "../helpers/icons";
import React from "react";
import VismerKnappen from "./VismerKnappen";
import {useHistory, withRouter} from "react-router-dom";
import qs from "query-string";


const Favoritter = ({hunder}) => {
    let history = useHistory();
    const parsed = qs.parse(decodeURI(history.location.search));

    let antallVises = 5;
    if (parsed.fav !== undefined) {
        antallVises = parsed.fav;
    }
    const setAntallVises = (antall) => {
        let params = parsed;
        params.fav = antall;
        history.push(history.location.pathname + "?" + qs.stringify(params));
    };

    const rows = hunder
        .map(f =>
            <DoglinkElement
                key={f.id}
                linkTo={`/hund?id=${f.hundId}`}
                iconFirst={icons.fav}
                iconLast={icons.arb}
                data={f}
            />
    ).splice(0, antallVises);


    return (
        <>
            { hunder && hunder.length > 0 &&
                <li>
                    <strong>MINE FAVORITTER</strong>
                    <ul>
                        {rows}

                        <VismerKnappen
                            total={hunder.length}
                            maxStep="10"
                            renderedAmount={antallVises}
                            incrementer={setAntallVises}
                        />
                    </ul>
                </li>
            }

        </>
    );

};
export default withRouter (Favoritter);